'use client';

import { useEffect } from 'react';
import createLoggerBrowser from '@action/log/browser';

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    if (error.name) {
      const log = createLoggerBrowser();

      log.error(error);
    }
  }, [error]);

  return (
    <html lang="ru">
      <body>
        <main>
          <h1>Что-то пошло не так</h1>
          <button onClick={() => reset()} type="button">
            Попробовать снова
          </button>
          <pre>
            Детали ошибки
            <br />
            <br />
            Name: {error.name}
            <br />
            Message: {error.message}
            <br />
            Stack: {error.stack}
          </pre>
        </main>
      </body>
    </html>
  );
}
